import request from '../utils/request'

import service from '../config/services';

const { domain: { jimu, jimuai } } = service;

//添加行为统计
export function addBehaviorstats(data) {
  return request({
    // url: `${jimu}/api/behaviorstats/add.do`,
    url: `${jimu}/api/behaviorstats/add.do`,
    method: 'get',
    params: data,
    hideError: true,
  })
}

export function getAlbums(id) {
  return request({
    url: `${jimuai}/prod-api/api/gallery/albums/${id}/structure`,
    method: 'get',
  })
}